import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {BusinessProcessService} from '../../../services/business-process.service';
import {HumanInteractionService} from '../../../services/human-interaction.service';
import {take, tap} from 'rxjs/operators';
import {PaginationInstance} from 'ngx-pagination';
import {WebClientConfigurationService} from '../../../services/configuration/web-client-configuration.service';
import {GenericModalService} from '../../../services/generic-modal.service';
import {InteractionQueueConfigService} from '../../../services/interaction-queue-config.service';
import {Utils} from '../../../services/utils';
import {Router} from '@angular/router';

@Component({
  selector: 'app-new-interaction-queue-configuration',
  templateUrl: './custom-interaction-queue-config-list.component.html',
  styleUrls: ['./custom-interaction-queue-config-list.component.css']
})
export class CustomInteractionQueueConfigListComponent implements OnInit {

  config: PaginationInstance;
  publishedBusinessProcess = [];
  customQueueConfigForm: FormGroup;
  errorMessage = '';
  successMessage = '';
  loadingList = false;
  customInteractionQueueConfigList: any[];
  pageIndex = 1;
  totalPagination = 0;
  totalCustomQueueListed: number;
  isRemoving = false;
  isDuplicating = false;
  constructor(private formBuilder: FormBuilder, private bpService: BusinessProcessService, private modalService: GenericModalService,
              private interactionQueueConfig: InteractionQueueConfigService, private webClientConfig: WebClientConfigurationService,
              private router: Router) { }

  get formData() { return this.customQueueConfigForm.controls; }

  ngOnInit() {
    this.createForm();
    this.getAllBpPublished();
    this.getQueueConfig(1, false);
  }

  createForm() {
    this.customQueueConfigForm = this.formBuilder.group({
      queueName: null,
      businessProcessId: null
    });
  }

  getAllBpPublished() {
    this.errorMessage = '';
    this.bpService.getAllBusinessProcessesPublished().subscribe(s => {
      this.publishedBusinessProcess = s;
    }, error1 => {
      this.errorMessage = error1;
    });
  }

  resetFilter() {
    this.customQueueConfigForm.reset();
  }

  getQueueConfig(page: number, hideFilter = true) {
    this.errorMessage = '';
    const filter = this.customQueueConfigForm.getRawValue();
    filter.queueName = filter.queueName === '' ? null : filter.queueName;
    page = (this.totalCustomQueueListed == 1 && this.isRemoving && page > 1) ? page - 1 : page;
    page = this.isDuplicating ? this.totalPagination : page;
    this.isRemoving = false;
    this.isDuplicating = false;

    filter.pageIndex = this.pageIndex = page;

    this.customInteractionQueueConfigList = [];

    this.loadingList = true;
    this.interactionQueueConfig.getCustomInteractionQueueConfigList(filter)
      .pipe(tap( res => {
        this.getPaginationConfig(page, res.total);
      }))
      .subscribe(ret => {
        this.customInteractionQueueConfigList = ret.items.sort((n1, n2) => {
          if (n1.name > n2.name) {
            return 1;
          }

          if (n1.name < n2.name) {
            return -1;
          }

          return 0;
        });
        if (hideFilter && ret.items.length > 0) {
          this.closeFilter();
        }
        this.totalCustomQueueListed = this.customInteractionQueueConfigList.length;
        this.loadingList = false;
      }, error1 => {
        this.errorMessage = error1;
      });
  }

  closeFilter() {
    // recolher os filtros, para melhor visualização do resultado
    document.getElementById('cardFilter').classList.add('collapsed-card');
    document.getElementById('bodyFilter').style.display = 'none';
    document.getElementById('footerFilter').style.display = 'none';

    // fechar o filtro
    const collapseFilter = document.getElementById('collapseFilter');
    collapseFilter.classList.add('fa-plus');
    collapseFilter.classList.remove('fa-minus');
  }

  getPaginationConfig(_currentPage: number, _totalItems: number) {
    this.errorMessage = '';
    this.webClientConfig.getPageSizeConfig().subscribe(item => {
      // tratamento para enviar a última pagina quando for nova fila, para que atualize corretamente
      let totalPages = Math.ceil(_totalItems / item);
      let totalItems = _totalItems / item;
      // verificar se o valor sem arredondamento é menor que o valor arredondado
      // se for menor, quer dizer que ainda estará nesta página, caso contrário, deverá estar na próxima página
      this.totalPagination = totalItems < totalPages ? totalPages : totalPages + 1;

      this.config  = {
        id: 'server',
        itemsPerPage: item,
        currentPage: _currentPage,
        totalItems: _totalItems
      };
    }, error1 => this.errorMessage = error1);
  }

  cloneConfig(queue) {
    this.errorMessage = '';
    this.successMessage = '';
    let alert: any;
    alert = this.modalService.showConfirmModal('Confirmação de Duplicação da Fila',
      `Confirma a duplicação da fila <b>${queue.name}</b>?`);
    alert.then((result) => {
      if (result.value) {
        this.interactionQueueConfig.cloneCustomInteractionQueueConfig(queue.id).subscribe(r => {
          this.successMessage = 'Fila duplicada com sucesso!';
          setTimeout(() => {
            this.isDuplicating = true;
            this.getQueueConfig(this.pageIndex);
            this.successMessage = '';
          }, 1500);
        }, error1 => {
          this.errorMessage = error1;
        });
      }
    });
  }

  deleteConfig(queue) {
    this.errorMessage = '';
    this.successMessage = '';
    queue = this.removeExtensionData(queue);
    let alert: any;
    alert = this.modalService.showConfirmModal('Confirmação de Exclusão da Fila',
      `Confirma a exclusão da fila <b>${queue.name}</b>?`);
    alert.then((result) => {
      if (result.value) {
        this.interactionQueueConfig.deleteCustomInteractionQueueConfig(queue).subscribe(r => {
          this.successMessage = 'Fila excluída com sucesso!';
          setTimeout(() => {
            this.isRemoving = true;
            this.getQueueConfig(this.pageIndex);
            this.successMessage = '';
          }, 1500);
        }, error1 => {
          this.isRemoving = false;
          this.errorMessage = error1;
        });
      }
    });
  }

  onCreateOrEdit(id = 0) {
    if (id > 0) {
      localStorage.setItem('customQueuePageIndex', this.pageIndex.toString());
      this.router.navigate(['/configCustomQueue', id]);
    } else {
      localStorage.setItem('customQueuePageIndex', this.totalPagination.toString());
      this.router.navigate(['/newConfigCustomQueue']);
    }
  }

  removeExtensionData(item) {
    const key = 'extensionData';
    delete item[key];
    if (item['colors'].length > 0) {
      item['colors'] = this.getNewArray(item['colors'], [key]);
    }
    if (item['fieldColumns'].length > 0) {
      item['fieldColumns'] = this.getNewArray(item['fieldColumns'], [key]);
    }
    if (item['groups'].length > 0) {
      item['groups'] = this.getNewArray(item['groups'], [key]);
    }
    if (item['overflowQueues'].length > 0) {
      item['overflowQueues'] = this.getNewArray(item['overflowQueues'], [key]);
    }
    if (item['users'].length > 0) {
      item['users'] = this.getNewArray(item['users'], [key]);
    }
    if (item['orderByColumn']) {
      item['orderByColumn'][key] = null;
    }
    return item;
  }

  getNewArray(array, keys = []) {
    return array.map(obj => Utils.mapOut(obj, keys));
  }

}
